import BackboneElement from './BackboneElement';
import CodeableConcept from './types/CodeableConcept';
import Reference from './types/Reference';
import Identifier from './types/Identifier';

import merge from 'lodash/merge';

export default class ClaimRelated extends BackboneElement {
    static __className = 'ClaimRelated';

    __objectStructure = {
        claim: Reference,
        relationship: CodeableConcept,
        reference: Identifier,
    };

    constructor(constructJson, className = 'ClaimRelated') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
